import { ServiceGroupData } from 'chaika-frontend-types/frontend-cms';

import { SimpleLongList } from '@store/models/SimpleLongList';

export class ServiceGroupList extends SimpleLongList<ServiceGroupData> {}
